import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalContentText,
  ModalTitle,
} from '@deere/fuel-react';
import React from 'react';
import './CustomInputModel.css';

const CustomModel = ({
  title,
  subTitle,
  primaryButtonText,
  secondaryButtonText,
  primaryClickHandler,
  closeHandler,
  isVisible,
  className,
}) => {
  return (
    <Modal
      className={'custom-model-popup' + ' ' + className}
      aria-describedby={'alert-Modal-description'}
      aria-labelledby={'alert-Modal-title'}
      open={isVisible}
      showClose={!!secondaryButtonText}
      onClose={closeHandler}
    >
      <ModalTitle
        id={'alert-Modal-title'}
        className="custom-model custom-model-title"
      >
        {title}
      </ModalTitle>
      <ModalContent className="custom-model custom-model-desc">
        <ModalContentText id={'alert-Modal-description'}>
          {subTitle}
        </ModalContentText>
      </ModalContent>
      <ModalActions>
        {secondaryButtonText && (
          <Button
            id="closeButton"
            variant={'secondary'}
            onClick={() => {
              closeHandler();
            }}
          >
            {secondaryButtonText}
          </Button>
        )}
        <Button
          id={'primaryButton'}
          variant={'primary'}
          onClick={() => {
            primaryClickHandler();
          }}
        >
          {primaryButtonText}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default CustomModel;
